<template>
    <div style="background: #f2f2f2;" v-show="show">
        <common-head active="0" state="1"></common-head>

        <!-- 标题 -->
        <div class="title">
            {{info.match_name}}</span>
        </div>

        <!-- 顶部大图 -->
        <div class="banner" @click="match">
            <img :src="info.match_main_image">
        </div>

        <!-- 内容 -->
        <div class="main">
            <div class="left">
                <div class="cate">
                    <div class="match" @click="match">立即购买</div>
                    <div class="cate-content" @click="change(index)" :class="active==index?'active':''"
                        v-for="(item,index) in cate" :key="index">{{item.cate_name}}</div>
                </div>
            </div>
            <div class="right">
                <div class="content" v-html="content.cate_content"></div>
            </div>
        </div>


        <common-footer></common-footer>
    </div>
</template>

<script>
    import { site_name } from '@/static/js/common.js';
    import commonHead from '@/components/pc/commonHead.vue';
    import commonFooter from '@/components/pc/commonFooter.vue';
    import { common_match } from '@/api/common.js';

    export default {
        name: 'match',
        components: {
            commonHead, commonFooter
        },
        data() {
            return {
                show: false,
                info: { match_name: '产品' },
                cate: [],
                active: 0,
            }
        },
        computed: {
            content() {
                if (this.cate.length) {
                    return this.cate[this.active];
                } else {
                    return { cate_content: '' };
                }
            },
        },
        metaInfo() {
            site_name().then(res => {
                document.title = this.info.match_name + '-' + res.site_name;
                return {
                    title: this.info.match_name + '-' + res.site_name,
                    meta: [
                        { name: "keywords", content: "" },
                        { name: "description", content: "" },
                        { name: 'viewport', content: 'width=device-width, initial-scale=0, maximum-scale=0, user-scalable=yes,shrink-to-fit=no' }
                    ],
                }
            });
        },
        created() {
            const id = this.$route.query.id;
            this.get_data(id);

        },
        methods: {
            get_data(id) {
                common_match({ id: id }).then(res => {
                    if (res.code == 1) {
                        this.info = res.data.info;
                        this.cate = res.data.cate;
                        this.show = true;
                    }
                });
            },
            change(e) {
                this.active = e;
            },
            match() {
                window.location.href = this.info.match_url;
            },
        },
    }
</script>
<style scoped>
    .banner {
        width: 1300px;
        margin: 0 auto;
        margin-top: 40px;
    }

    .banner img {
        width: 100%;
    }

    .main {
        width: 1300px;
        margin: 0 auto;
        margin-top: 30px;
        margin-bottom: 100px;
        border-radius: 20px;
        position: relative;
        display: flex;
    }

    .left {
        width: 180px;
        vertical-align: top;
        background-color: #fff;
        margin-right: 20px;
        border-radius: 20px;
    }

    .right {
        width: 1100px;
        vertical-align: top;
        background-color: #fff;
        flex: 1;
    }

    .cate {
        margin: 0 0 20px;
        font-size: 14px;
    }

    .cate-content {
        line-height: 3;
        padding-left: 30px;
        cursor: pointer;
        border-left: 3px solid #fff;
    }

    .content {
        padding: 20px 30px;
        line-height: 2;
        font-size: 16px;
    }

    /deep/ .content img {
        max-width: 1000px !important;
    }

    .active {
        color: #a0ca32;
        font-weight: 700;
        border-left: 3px solid #a0ca32;
    }

    .title {
        width: 1300px;
        margin: 0 auto;
        margin-top: 40px;
        font-size: 24px;
        font-weight: 700;
        position: relative;
    }

    .time {
        font-size: 16px;
        font-weight: 400;
        margin-top: 10px;
        color: #666;
    }

    .time span {
        margin-right: 50px;
    }

    .type {
        background-color: #a0ca32;
        padding: 3px 10px;
        color: #fff;
        font-size: 14px;
        font-weight: 600;
        border-radius: 5px;
    }

    .submit {
        position: absolute;
        right: 0;
        top: 0;
        background-color: #a0ca32;
        color: #fff;
        padding: 0 30px;
        height: 50px;
        line-height: 50px;
        border-radius: 25px;
        cursor: pointer;
    }

    .match {
        text-align: center;
        background-color: #a0ca32;
        color: #fff;
        font-size: 18px;
        font-weight: 700;
        padding: 15px 0;
        margin-bottom: 15px;
        cursor: pointer;
    }
</style>